import { Column, ModelBase } from 'loca-boot-core'
import { secondsToHm } from '@/utils/time'

export enum ResourceType {
  ChargeStation = 'ChargeStation',
  PowerSwap = 'PowerSwap',
  ThirdChargeStation = 'ThirdChargeStation',
  NioChargeStationNpc = 'NioChargeStationNpc',
}

/**
 * 加电资源
 */
export class EnergyStationModel extends ModelBase {
  @Column()
  public id!: string
  @Column()
  public name!: string

  @Column({ name: 'charge_station_type' })
  public chargeStationType!: ResourceType

  /**
   * 资源点类型 20231221新增
   * RECHARGE :recharge 充换电资源 NIO_STORE :nio_store 蔚来门店资源 TEST_DRIVE :test_drive 试驾点资源
   */
  @Column()
  public pointType!: string

  /**
   * 资源点子类型 20231221新增
   * POWER_SWAP :PowerSwap 换电站资源 CHARGE_STATION :ChargeStation 充电站资源 NIO_SPACE :NioSpace 蔚来空间 NIO_HOUSE :NioHouse 蔚来中心 TEST_DRIVE :TestDrive 试驾点
   */
  @Column()
  public pointSubType!: string

  @Column()
  public type!: ResourceType

  @Column()
  public location!: string

  @Column()
  public address!: string
  /**
   * 加电资源是否可点击
   */
  @Column()
  public clickAvailable!: boolean
}

export class EnergyResourceModel extends ModelBase {
  @Column({ name: 'resource', childType: EnergyStationModel })
  public resource!: EnergyStationModel

  // 资源类型
  @Column({ name: 'station_type' })
  public stationType!: string

  // 位置
  @Column({ name: 'location' })
  public location!: string

  // 是否推荐资源，取resources_and_points下station_type为candidate
  public get isCandidate() {
    return this.stationType === 'candidate'
  }

  // 取resources_and_points下prev_candidate_point_distance
  @Column({ name: 'prev_candidate_point_distance' })
  public prevCandidateDistance!: number

  // 取resources_and_poin下next_candidate_point_distance
  @Column({ name: 'next_candidate_point_distance' })
  public nextCandidateDistance!: number

  // 加电时间，整个文案改成全部取card_steps下subtitle
  @Column({ name: 'estimate_charge_duration' })
  public estimateChargeDuration!: number

  // 取resources_and_points下next_candidate_point_distance_desc，计算好了不需要计算
  // public get nextCandidateDistanceDesc() {
  //   return `${distanceFormat(this.nextCandidateDistance)}`
  // }
  @Column({ name: 'next_candidate_point_distance_desc' })
  public nextCandidateDistanceDesc!: string

  // 不需要了，直接使用上面的estimateChargeDuration
  public get estimateChargeDurationDesc() {
    return `约${secondsToHm(this.estimateChargeDuration)}`
  }

  public get name() {
    return this.resource.name
  }

  public get address() {
    return this.resource.address
  }

  public get type() {
    return this.resource.type
  }

  public get chargeStationType() {
    return this.resource.chargeStationType
  }

  public get id() {
    return this.resource.id
  }
}

export class EnergyCardStepsModel extends ModelBase {
  // 资源ID
  @Column({ name: 'resource_id' })
  public id!: string

  // 资源POI
  @Column({ name: 'poi' })
  public poi!: boolean

  // 资源Title
  @Column({ name: 'title' })
  public title!: string

  // 资源类型
  @Column({ name: 'resource_type' })
  public type!: ResourceType

  // 充电站类型
  @Column({ name: 'charge_station_type' })
  public chargeStationType!: ResourceType

  // 位置
  @Column({ name: 'location' })
  public location!: string

  // 取resources_and_poin下next_candidate_point_distance
  @Column({ name: 'distance_desc' })
  public distanceDesc!: string

  // 加电时间，整个文案改成全部取card_steps下subtitle
  @Column({ name: 'subtitle' })
  public subTitle!: string
}

export class EnergyStepModel extends ModelBase {
  @Column()
  public polyline!: string
  @Column()
  public distance!: number
  @Column()
  public status!: number
}

export class EnergySummaryModel extends ModelBase {
  // tag_desc改成简短的brief_tag_desc
  @Column({ name: 'brief_tag_desc' })
  public tagDesc!: string

  // 中途加电次数summary.plan_charge_count
  @Column({ name: 'plan_charge_count' })
  public candidateCount!: number

  // 行驶距离summary.drive_distance_desc，算好了不需要计算
  @Column({ name: 'drive_distance_desc' })
  public distanceDesc!: string

  // 行驶时间summary.drive_distance_desc，算好了不需要计算
  @Column({ name: 'plan_drive_duration_desc' })
  public durationDesc!: string

  // 行驶距离summary.drive_distance
  @Column({ name: 'drive_distance' })
  public distance!: number

  // 行驶时间summary.plan_drive_duration
  // @Column({ name: 'plan_driver_duration' })
  // public duration!: number;

  // 加电时间summary.plan_charge_duration_desc，算好了不需要计算
  @Column({ name: 'plan_charge_duration_desc' })
  public estimateChargeDuration!: string
}

/**
 * 沿途补能规划
 */
// export class EnergyPlanModel extends ModelBase {

//   @Column({ name: 'candidate_count' })
//   public candidateCount!: number

//   @Column({ name: 'resources', childType: EnergyResourceModel })
//   public resources!: EnergyResourceModel[];

//   @Column({ name: 'route', childType: EnergyRouteModel })
//   public route!: EnergyRouteModel;

//   @Column({ name: 'tag' })
//   public tag!: string;

//   @Column({ name: 'tag_desc', default: '推荐路线' })
//   public tagDesc!: string;
// }

/**
 * location
 */
export class LocationModel extends ModelBase {
  @Column({ name: 'dest' })
  public dest!: string

  @Column({ name: 'orig' })
  public orig!: string
}

/**
 * 路径规划（新）
 */
export class EnergyPlanNewModel extends ModelBase {
  @Column({ name: 'route_id' })
  public routeId!: string

  @Column({ name: 'summary', childType: EnergySummaryModel })
  public summary!: EnergySummaryModel

  @Column({ name: 'card_steps', childType: EnergyCardStepsModel })
  public cardSteps!: EnergyCardStepsModel[]

  @Column({ name: 'steps', childType: EnergyStepModel })
  public steps!: EnergyStepModel[]

  @Column({ name: 'resources_and_points', childType: EnergyResourceModel })
  public resources!: EnergyResourceModel[]

  // @Column({ name: 'route', childType: EnergyRouteModel })
  // public route!: EnergyRouteModel;

  @Column({ name: 'locations', childType: LocationModel })
  public locations!: LocationModel
}

/**
 * 沿途补能规划
 */
// export class EnergyPlanDataModel extends ModelBase {

//   @Column({ name: 'locations', childType: LocationModel })
//   public locations!: LocationModel;

//   @Column({ name: 'plan', childType: EnergyPlanModel })
//   public plan!: EnergyPlanModel;

//   @Column({ name: 'plans', childType: EnergyPlanModel })
//   public origPlans!: EnergyPlanModel[];

//   get plans() {
//     if (this.origPlans?.length > 3) {
//       return this.origPlans.slice(0, 3);
//     }
//     return this.origPlans;
//   }

// }
/**
 * 路径规划（新）
 */
export class EnergyPlanNewDataModel extends ModelBase {
  // @Column({ name: 'locations', childType: LocationModel })
  // public locations!: LocationModel;

  @Column({ name: 'plans', childType: EnergyPlanNewModel })
  public origPlans!: EnergyPlanNewModel[]

  get plans() {
    if (this.origPlans?.length > 3) {
      return this.origPlans.slice(0, 3)
    }
    return this.origPlans
  }
}
